/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { getAuthToken } from '../helper/storage'

export default function PrivateRoute({ children }) {
  const [isToastShown, setIsToastShown] = useState(false)
  const authToken = getAuthToken()

  useEffect(() => {
    if (!authToken && !isToastShown) {
      // errorToast('Session Expired!')
      setIsToastShown(true)
    }
  }, [authToken, isToastShown])

  if (!authToken) {
    return <Navigate to="/login" replace />
  }
  return <React.Suspense fallback={<>...</>}>{children}</React.Suspense>
}
